import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FieldRow: FunctionComponent<Props> = ({ label, testId = TEST_ID, value }) => (
    <HorizontalContainer className={styles.fieldRow} testId={testId}>
        <Wrapper className={styles.fieldLabel}>{label}</Wrapper>

        <Wrapper className={styles.fieldValue}>{value}</Wrapper>
    </HorizontalContainer>
);

export default FieldRow;
